module.exports = __webpack_public_path__ + "img/blue-down-arrow.05ecb4e5.svg";